// extracted by mini-css-extract-plugin
export default {"cssbuttons_io_button":"StyleButton_cssbuttons_io_button__Jh6C0"};